import React from 'react';
import StyledToolTip from '@rental-manager/components/StyledTooltip';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

const DepositDateTooltipComponent = (): JSX.Element | null => (
  <StyledToolTip className="Dashboard-ledger-tooltip" iconName="help-circle-fill">
    <Text>
      Because it takes the banks up to 5 business days to process a payment, weekends and holidays extends the total
      processing time.
    </Text>
  </StyledToolTip>
);

export default DepositDateTooltipComponent;
